<template>
  <a-modal width="55%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk"  @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-form-model ref="form" :model="form"  :rules="rules">
      <a-form-item class="margin-bottom-10">
        <a-table :data-source="form.skuList"
                 :customRow="loadCustomRow"
                 :columns="skuColumns"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio',  onChange: onSelectChange}"
                 rowKey="id"
                 :pagination="false" bordered>
          <div slot="skuStockTitle">
            {{$t('库存')}}
            <a-tooltip>
              <template slot="title">
                <p>实时库存 + 锁定中的库存 = 目前显示中的库存数</p>
                <!--                <p>如果不对,请更新</p>-->
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
          <div slot="skuStock" slot-scope="text, record">
            <a-tooltip>{{ text }}
              <template slot="title">
                <p>实时库存{{ record.redisStock }}</p>
                <p>锁定中库存{{ record.lockStock }}</p>
              </template>
            </a-tooltip>
          </div>
        </a-table>
      </a-form-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {getGoodsStock, listSelectGoods, updateGoodsStock} from '@/api/goods/goods'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      selectedRowKeys: [],
      selectedRows: [],
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: this.$t('名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        }, {
          title: this.$t('编码'),
          dataIndex: 'skuCode',
          key: 'skuCode',
        }, {
          title: this.$t('价格'),
          dataIndex: 'price',
          key: 'price',
        },
        {
          title: this.$t('原始库存'),
          width: 100,
          dataIndex: 'sourceStock',
          key: 'sourceStock',
        },
        {
          slots: { title: 'skuStockTitle' },
          width: 100,
          scopedSlots: {customRender: 'skuStock'},
          dataIndex: 'stock',
          key: 'stock',
        },
      ],
      object:null,
      // 表单参数
      form: {
        id: null,
        skuList: [],
        name: null,

        icon: null,

        color: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.object=null
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.limitNum) {
          if (this.selectedRows.length >= this.limitNum) {
            console.log('到达了限制数量,',this.limitNum)
            return false
          }
        }
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          dblclick: () => {
            this.onOk()
          },
        }
      }
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsSelect', this.selectedRowKeys[0], this.object)
      this.reset()
    },
    /** 修改按钮操作 */
    show(goodsId, object) {
      this.reset()
      this.object = object
      this.formType = 2
      getGoodsStock({"id":goodsId}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改库存'
      })
    },
    /** 提交按钮 */
  }
}
</script>
